import { Injectable } from '@angular/core';
import { TownEndPoints } from 'src/app/constants/api-endpoints';
import { Town } from 'src/app/models/doctor/doctor-town.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/sections/common/services/api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TownTableService {

  townUrls = TownEndPoints;

  constructor(private _apiService: ApiService) { }

  private returnResponse(response) {
    if (response._statusCode > 399) {
      throw (response);
    }
    return response;
  }

  getTownsPaginated(pageSize: number, page: number): Observable<Town> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    const query = params.toString().replace('+', '%20');

    return this._apiService.get(this.townUrls.getTownListPaginated + '?' + `${query}`, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  saveTown(town: Town): Observable<Town> {
    return this._apiService.post(this.townUrls.saveTown, town, true, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  updateTown(id: number, town: Town): Observable<Town> {
    return this._apiService.put(this.townUrls.updateTown + id, town, true, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  deleteTown(id: number): Observable<Town> {
    return this._apiService.delete(this.townUrls.deleteTown, id.toString(), true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

}
